import { render, staticRenderFns } from "./ClientInfoPanel.vue?vue&type=template&id=8c536740&scoped=true&"
import script from "./ClientInfoPanel.vue?vue&type=script&lang=js&"
export * from "./ClientInfoPanel.vue?vue&type=script&lang=js&"
import style0 from "./ClientInfoPanel.vue?vue&type=style&index=0&id=8c536740&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c536740",
  null
  
)

export default component.exports